// Date 2021-09-27 20:32:25

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import mintalMesPrdSmeltingMaterialBatchingEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingMaterialBatchingEdit.vue";
import mintalMesPrdSmeltingMaterialBatchingList from "@/views/mintalMes/prd/MintalMesPrdSmeltingMaterialBatchingList.vue";
import mintalMesPrdSmeltingPreheatingKilnList from "@/views/mintalMes/prd/MintalMesPrdSmeltingPreheatingKilnList.vue";
import mintalMesPrdSmeltingPreheatingKilnEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingPreheatingKilnEdit.vue";
import mintalMesPrdSmeltingFurnaceMeasureEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingFurnaceMeasureEdit.vue";
import mintalMesPrdSmeltingFurnaceMeasureList from "@/views/mintalMes/prd/MintalMesPrdSmeltingFurnaceMeasureList.vue";
import mintalMesPrdSmeltingCoolingWaterEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingCoolingWaterEdit.vue";
import mintalMesPrdSmeltingCoolingWaterList from "@/views/mintalMes/prd/MintalMesPrdSmeltingCoolingWaterList.vue";
import mintalMesPrdSmeltingFurnaceLiningTemperatureList from "@/views/mintalMes/prd/MintalMesPrdSmeltingFurnaceLiningTemperatureList.vue";
import mintalMesPrdSmeltingFurnaceLiningTemperatureEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingFurnaceLiningTemperatureEdit.vue";
import mintalMesPrdSmeltingElectrodePasteList from "@/views/mintalMes/prd/MintalMesPrdSmeltingElectrodePasteList.vue";
import mintalMesPrdSmeltingElectrodePasteEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingElectrodePasteEdit.vue";
import mintalMesPrdSmeltingThickenerPumpList from "@/views/mintalMes/prd/MintalMesPrdSmeltingThickenerPumpList.vue";
import mintalMesPrdSmeltingThickenerPumpEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingThickenerPumpEdit.vue";
import mintalMesPrdSmeltingElectrodeDischargeList from "@/views/mintalMes/prd/MintalMesPrdSmeltingElectrodeDischargeList.vue";
import mintalMesPrdSmeltingElectrodeDischargeEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingElectrodeDischargeEdit.vue";
import mintalMesPrdSmeltingElectrodeWeightChangeList from "@/views/mintalMes/prd/MintalMesPrdSmeltingElectrodeWeightChangeList.vue";
import mintalMesPrdSmeltingElectrodeWeightChangeEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingElectrodeWeightChangeEdit.vue";
import mintalMesPrdSmeltingElectrodeParameterEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingElectrodeParameterEdit.vue";
import mintalMesPrdSmeltingElectrodeParameterList from "@/views/mintalMes/prd/MintalMesPrdSmeltingElectrodeParameterList.vue";
import mintalMesPrdSmeltingGasCabinetList from "@/views/mintalMes/prd/MintalMesPrdSmeltingGasCabinetList.vue";
import mintalMesPrdSmeltingGasCabinetEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingGasCabinetEdit.vue";
import mintalMesPrdSmeltingGasFlowList from "@/views/mintalMes/prd/MintalMesPrdSmeltingGasFlowList.vue";
import mintalMesPrdSmeltingGasFlowEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingGasFlowEdit.vue";
import mintalMesPrdSmeltingSlagIronEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingSlagIronEdit.vue";
import mintalMesPrdSmeltingSlagIronList from "@/views/mintalMes/prd/MintalMesPrdSmeltingSlagIronList.vue";
import mintalMesPrdSmeltingResistanceBeforeIronList from "@/views/mintalMes/prd/MintalMesPrdSmeltingResistanceBeforeIronList.vue";
import mintalMesPrdSmeltingResistanceBeforeIronEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingResistanceBeforeIronEdit.vue";
import mintalMesPrdSmeltingDrillParameterEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingDrillParameterEdit.vue";
import mintalMesPrdSmeltingDrillParameterList from "@/views/mintalMes/prd/MintalMesPrdSmeltingDrillParameterList.vue";
import mintalMesPrdSmeltingPelletFeedingEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingPelletFeedingEdit.vue";
import mintalMesPrdSmeltingPelletFeedingList from "@/views/mintalMes/prd/MintalMesPrdSmeltingPelletFeedingList.vue";
import mintalMesPrdSmeltingSubstationRecordList from "@/views/mintalMes/prd/MintalMesPrdSmeltingSubstationRecordList.vue";
import mintalMesPrdSmeltingSubstationRecordEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingSubstationRecordEdit.vue";
import mintalMesPrdSmeltingFurnacePowerFailureRecordList from "@/views/mintalMes/prd/MintalMesPrdSmeltingFurnacePowerFailureRecordList.vue";
import mintalMesPrdSmeltingFurnacePowerFailureRecordEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingFurnacePowerFailureRecordEdit.vue";
import mintalMesPrdPelletizingCeramicFilterParameterEdit from "@/views/mintalMes/prd/MintalMesPrdPelletizingCeramicFilterParameterEdit.vue";
import mintalMesPrdPelletizingCeramicFilterParameterList from "@/views/mintalMes/prd/MintalMesPrdPelletizingCeramicFilterParameterList.vue";
import mintalMesPrdMonthPlanEdit from "@/views/mintalMes/prd/MintalMesPrdMonthPlanEdit.vue";
import mintalMesPrdMonthPlanList from "@/views/mintalMes/prd/MintalMesPrdMonthPlanList.vue";
import mintalMesPrdShiftPlanEdit from "@/views/mintalMes/prd/MintalMesPrdShiftPlanEdit.vue";
import mintalMesPrdShiftPlanList from "@/views/mintalMes/prd/MintalMesPrdShiftPlanList.vue";
import mintalMesPrdDowntimePlanList from "@/views/mintalMes/prd/MintalMesPrdDowntimePlanList.vue";
import mintalMesPrdDowntimePlanEdit from "@/views/mintalMes/prd/MintalMesPrdDowntimePlanEdit.vue";
import mintalMesPrdMaterialRequirePlanEdit from "@/views/mintalMes/prd/MintalMesPrdMaterialRequirePlanEdit.vue";
import mintalMesPrdMaterialRequirePlanList from "@/views/mintalMes/prd/MintalMesPrdMaterialRequirePlanList.vue";
import mintalMesPrdProductionResultList from "@/views/mintalMes/prd/MintalMesPrdProductionResultList.vue";
import mintalMesPrdProductionResultEdit from "@/views/mintalMes/prd/MintalMesPrdProductionResultEdit.vue";
import mintalMesPrdProductionInfoList from "@/views/mintalMes/prd/MintalMesPrdProductionInfoList.vue";
import mintalMesPrdProductionInfoEdit from "@/views/mintalMes/prd/MintalMesPrdProductionInfoEdit.vue";
import mintalMesPrdProductionMaterialCostList from "@/views/mintalMes/prd/MintalMesPrdProductionMaterialCostList.vue";
import mintalMesPrdProductionMaterialCostEdit from "@/views/mintalMes/prd/MintalMesPrdProductionMaterialCostEdit.vue";
import mintalMesPrdProductionEnergyCostList from "@/views/mintalMes/prd/MintalMesPrdProductionEnergyCostList.vue";
import mintalMesPrdProductionEnergyCostEdit from "@/views/mintalMes/prd/MintalMesPrdProductionEnergyCostEdit.vue";
import mintalMesPrdShiftHandoverEdit from "@/views/mintalMes/prd/MintalMesPrdShiftHandoverEdit.vue";
import mintalMesPrdShiftHandoverList from "@/views/mintalMes/prd/MintalMesPrdShiftHandoverList.vue";
import mintalMesPrdCraftEdit from "@/views/mintalMes/prd/MintalMesPrdCraftEdit.vue";
import mintalMesPrdCraftList from "@/views/mintalMes/prd/MintalMesPrdCraftList.vue";
import mintalMesPrdCraftConfigList from "@/views/mintalMes/prd/MintalMesPrdCraftConfigList.vue";
import mintalMesPrdCraftConfigEdit from "@/views/mintalMes/prd/MintalMesPrdCraftConfigEdit.vue";
import mintalMesPrdCraftEnergyConfigEdit from "@/views/mintalMes/prd/MintalMesPrdCraftEnergyConfigEdit.vue";
import mintalMesPrdCraftEnergyConfigList from "@/views/mintalMes/prd/MintalMesPrdCraftEnergyConfigList.vue";
import mintalMesPrdCraftMaterialConfigEdit from "@/views/mintalMes/prd/MintalMesPrdCraftMaterialConfigEdit.vue";
import mintalMesPrdCraftMaterialConfigList from "@/views/mintalMes/prd/MintalMesPrdCraftMaterialConfigList.vue";
import mintalMesPrdFurnaceBatchList from "@/views/mintalMes/prd/MintalMesPrdFurnaceBatchList.vue";
import mintalMesPrdFurnaceBatchEdit from "@/views/mintalMes/prd/MintalMesPrdFurnaceBatchEdit.vue";
import mintalMesPrdSmeltingPreheatingKilnStopEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingPreheatingKilnStopEdit.vue";
import mintalMesPrdSmeltingPreheatingKilnStopList from "@/views/mintalMes/prd/MintalMesPrdSmeltingPreheatingKilnStopList.vue";
import mintalMesPrdManagePlanEdit from "@/views/mintalMes/prd/MintalMesPrdManagePlanEdit.vue";
import mintalMesPrdManagePlanList from "@/views/mintalMes/prd/MintalMesPrdManagePlanList.vue";
import mintalMesPrdPelletizingGrindingParameterEdit from "@/views/mintalMes/prd/MintalMesPrdPelletizingGrindingParameterEdit.vue";
import mintalMesPrdPelletizingGrindingParameterList from "@/views/mintalMes/prd/MintalMesPrdPelletizingGrindingParameterList.vue";
import mintalMesPrdPelletizingFilterParameterList from "@/views/mintalMes/prd/MintalMesPrdPelletizingFilterParameterList.vue";
import mintalMesPrdPelletizingFilterParameterEdit from "@/views/mintalMes/prd/MintalMesPrdPelletizingFilterParameterEdit.vue";
import mintalMesPrdPelletizingBallingParameterList from "@/views/mintalMes/prd/MintalMesPrdPelletizingBallingParameterList.vue";
import mintalMesPrdPelletizingBallingParameterEdit from "@/views/mintalMes/prd/MintalMesPrdPelletizingBallingParameterEdit.vue";
import mintalMesPrdPelletizingRoastingParameterEdit from "@/views/mintalMes/prd/MintalMesPrdPelletizingRoastingParameterEdit.vue";
import mintalMesPrdPelletizingRoastingParameterList from "@/views/mintalMes/prd/MintalMesPrdPelletizingRoastingParameterList.vue";
import mintalMesPrdPelletizingWaterSystemParameterList from "@/views/mintalMes/prd/MintalMesPrdPelletizingWaterSystemParameterList.vue";
import mintalMesPrdPelletizingWaterSystemParameterEdit from "@/views/mintalMes/prd/MintalMesPrdPelletizingWaterSystemParameterEdit.vue";
import mintalMesPrdPelletizingProductTreatmentParameterEdit from "@/views/mintalMes/prd/MintalMesPrdPelletizingProductTreatmentParameterEdit.vue";
import mintalMesPrdPelletizingProductTreatmentParameterList from "@/views/mintalMes/prd/MintalMesPrdPelletizingProductTreatmentParameterList.vue";
import mintalMesPrdPelletizingIngredientPlanList from "@/views/mintalMes/prd/MintalMesPrdPelletizingIngredientPlanList.vue";
import mintalMesPrdPelletizingIngredientPlanEdit from "@/views/mintalMes/prd/MintalMesPrdPelletizingIngredientPlanEdit.vue";
import mintalMesPrdPelletizingIngredientPlanItemList from "@/views/mintalMes/prd/MintalMesPrdPelletizingIngredientPlanItemList.vue";
import mintalMesPrdPelletizingIngredientPlanItemEdit from "@/views/mintalMes/prd/MintalMesPrdPelletizingIngredientPlanItemEdit.vue";
import mintalMesPrdSmeltingElectrodeDischargePlanEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingElectrodeDischargePlanEdit.vue";
import mintalMesPrdSmeltingElectrodeDischargePlanList from "@/views/mintalMes/prd/MintalMesPrdSmeltingElectrodeDischargePlanList.vue";
import mintalMesPrdIronOutputList from "@/views/mintalMes/prd/MintalMesPrdIronOutputList.vue";
import mintalMesPrdIronOutputEdit from "@/views/mintalMes/prd/MintalMesPrdIronOutputEdit.vue";
import mintalMesPrdPowerStationRecordList from "@/views/mintalMes/prd/MintalMesPrdPowerStationRecordList.vue";
import mintalMesPrdPowerStationRecordEdit from "@/views/mintalMes/prd/MintalMesPrdPowerStationRecordEdit.vue";
import mintalMesPrdSubstationPowerRecordList from "@/views/mintalMes/prd/MintalMesPrdSubstationPowerRecordList.vue";
import mintalMesPrdSubstationPowerRecordEdit from "@/views/mintalMes/prd/MintalMesPrdSubstationPowerRecordEdit.vue";
import mintalMesPrdProductionEquipQuotaList from "@/views/mintalMes/prd/MintalMesPrdProductionEquipQuotaList.vue";
import mintalMesPrdProductionEquipQuotaEdit from "@/views/mintalMes/prd/MintalMesPrdProductionEquipQuotaEdit.vue";
import mintalMesPrdGenertorSetDowntimeEdit from "@/views/mintalMes/prd/MintalMesPrdGenertorSetDowntimeEdit.vue";
import mintalMesPrdGenertorSetDowntimeList from "@/views/mintalMes/prd/MintalMesPrdGenertorSetDowntimeList.vue";
import mintalMesPrdFieldOpcConfigList from "@/views/mintalMes/prd/MintalMesPrdFieldOpcConfigList.vue";
import mintalMesPrdFieldOpcConfigEdit from "@/views/mintalMes/prd/MintalMesPrdFieldOpcConfigEdit.vue";
import mintalMesPrdSmeltingCirculatingWaterEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingCirculatingWaterEdit.vue";
import mintalMesPrdSmeltingCirculatingWaterList from "@/views/mintalMes/prd/MintalMesPrdSmeltingCirculatingWaterList.vue";
import mintalMesPrdSmeltingMaterialConsumptionList from "@/views/mintalMes/prd/MintalMesPrdSmeltingMaterialConsumptionList.vue";
import mintalMesPrdSmeltingMaterialConsumptionEdit from "@/views/mintalMes/prd/MintalMesPrdSmeltingMaterialConsumptionEdit.vue";
const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingMaterialBatchingEdit",
            name: "mintalMesPrdSmeltingMaterialBatchingEdit",
            component: mintalMesPrdSmeltingMaterialBatchingEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingMaterialBatchingList",
            name: "mintalMesPrdSmeltingMaterialBatchingList",
            component: mintalMesPrdSmeltingMaterialBatchingList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdMonthPlanEdit",
            name: "mintalMesPrdMonthPlanEdit",
            component: mintalMesPrdMonthPlanEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdMonthPlanList",
            name: "mintalMesPrdMonthPlanList",
            component: mintalMesPrdMonthPlanList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdShiftPlanEdit",
            name: "mintalMesPrdShiftPlanEdit",
            component: mintalMesPrdShiftPlanEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdShiftPlanList",
            name: "mintalMesPrdShiftPlanList",
            component: mintalMesPrdShiftPlanList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdDowntimePlanList",
            name: "mintalMesPrdDowntimePlanList",
            component: mintalMesPrdDowntimePlanList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdDowntimePlanEdit",
            name: "mintalMesPrdDowntimePlanEdit",
            component: mintalMesPrdDowntimePlanEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdMaterialRequirePlanEdit",
            name: "mintalMesPrdMaterialRequirePlanEdit",
            component: mintalMesPrdMaterialRequirePlanEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdMaterialRequirePlanList",
            name: "mintalMesPrdMaterialRequirePlanList",
            component: mintalMesPrdMaterialRequirePlanList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionPelletizingResultList",
            name: "mintalMesPrdProductionPelletizingResultList",
            component: mintalMesPrdProductionResultList,
            props: (route) => ({ prop_inline: route.query.inline, customVuexName: 'pelletizing' }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionSmeltingResultList",
            name: "mintalMesPrdProductionSmeltingResultList",
            component: mintalMesPrdProductionResultList,
            props: (route) => ({ prop_inline: route.query.inline, customVuexName: 'smelting' }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionResultEdit",
            name: "mintalMesPrdProductionResultEdit",
            component: mintalMesPrdProductionResultEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionInfoList",
            name: "mintalMesPrdProductionInfoList",
            component: mintalMesPrdProductionInfoList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionInfoEdit",
            name: "mintalMesPrdProductionInfoEdit",
            component: mintalMesPrdProductionInfoEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionMaterialCostList",
            name: "mintalMesPrdProductionMaterialCostList",
            component: mintalMesPrdProductionMaterialCostList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionMaterialCostEdit",
            name: "mintalMesPrdProductionMaterialCostEdit",
            component: mintalMesPrdProductionMaterialCostEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionEnergyCostList",
            name: "mintalMesPrdProductionEnergyCostList",
            component: mintalMesPrdProductionEnergyCostList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionEnergyCostEdit",
            name: "mintalMesPrdProductionEnergyCostEdit",
            component: mintalMesPrdProductionEnergyCostEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdShiftHandoverEdit",
            name: "mintalMesPrdShiftHandoverEdit",
            component: mintalMesPrdShiftHandoverEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdShiftHandoverList",
            name: "mintalMesPrdShiftHandoverList",
            component: mintalMesPrdShiftHandoverList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdCraftEdit",
            name: "mintalMesPrdCraftEdit",
            component: mintalMesPrdCraftEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdCraftList",
            name: "mintalMesPrdCraftList",
            component: mintalMesPrdCraftList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdCraftConfigList",
            name: "mintalMesPrdCraftConfigList",
            component: mintalMesPrdCraftConfigList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdCraftConfigEdit",
            name: "mintalMesPrdCraftConfigEdit",
            component: mintalMesPrdCraftConfigEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdCraftEnergyConfigEdit",
            name: "mintalMesPrdCraftEnergyConfigEdit",
            component: mintalMesPrdCraftEnergyConfigEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdCraftEnergyConfigList",
            name: "mintalMesPrdCraftEnergyConfigList",
            component: mintalMesPrdCraftEnergyConfigList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdCraftMaterialConfigEdit",
            name: "mintalMesPrdCraftMaterialConfigEdit",
            component: mintalMesPrdCraftMaterialConfigEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdCraftMaterialConfigList",
            name: "mintalMesPrdCraftMaterialConfigList",
            component: mintalMesPrdCraftMaterialConfigList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingPreheatingKilnList",
            name: "mintalMesPrdSmeltingPreheatingKilnList",
            component: mintalMesPrdSmeltingPreheatingKilnList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingPreheatingKilnEdit",
            name: "mintalMesPrdSmeltingPreheatingKilnEdit",
            component: mintalMesPrdSmeltingPreheatingKilnEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingFurnaceMeasureEdit",
            name: "mintalMesPrdSmeltingFurnaceMeasureEdit",
            component: mintalMesPrdSmeltingFurnaceMeasureEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingFurnaceMeasureList",
            name: "mintalMesPrdSmeltingFurnaceMeasureList",
            component: mintalMesPrdSmeltingFurnaceMeasureList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingCoolingWaterEdit",
            name: "mintalMesPrdSmeltingCoolingWaterEdit",
            component: mintalMesPrdSmeltingCoolingWaterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingCoolingWaterList",
            name: "mintalMesPrdSmeltingCoolingWaterList",
            component: mintalMesPrdSmeltingCoolingWaterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingFurnaceLiningTemperatureList",
            name: "mintalMesPrdSmeltingFurnaceLiningTemperatureList",
            component: mintalMesPrdSmeltingFurnaceLiningTemperatureList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingFurnaceLiningTemperatureEdit",
            name: "mintalMesPrdSmeltingFurnaceLiningTemperatureEdit",
            component: mintalMesPrdSmeltingFurnaceLiningTemperatureEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingElectrodePasteList",
            name: "mintalMesPrdSmeltingElectrodePasteList",
            component: mintalMesPrdSmeltingElectrodePasteList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingElectrodePasteEdit",
            name: "mintalMesPrdSmeltingElectrodePasteEdit",
            component: mintalMesPrdSmeltingElectrodePasteEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingThickenerPumpList",
            name: "mintalMesPrdSmeltingThickenerPumpList",
            component: mintalMesPrdSmeltingThickenerPumpList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingThickenerPumpEdit",
            name: "mintalMesPrdSmeltingThickenerPumpEdit",
            component: mintalMesPrdSmeltingThickenerPumpEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingElectrodeDischargeList",
            name: "mintalMesPrdSmeltingElectrodeDischargeList",
            component: mintalMesPrdSmeltingElectrodeDischargeList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingElectrodeDischargeEdit",
            name: "mintalMesPrdSmeltingElectrodeDischargeEdit",
            component: mintalMesPrdSmeltingElectrodeDischargeEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingElectrodeWeightChangeList",
            name: "mintalMesPrdSmeltingElectrodeWeightChangeList",
            component: mintalMesPrdSmeltingElectrodeWeightChangeList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingElectrodeWeightChangeEdit",
            name: "mintalMesPrdSmeltingElectrodeWeightChangeEdit",
            component: mintalMesPrdSmeltingElectrodeWeightChangeEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingElectrodeParameterEdit",
            name: "mintalMesPrdSmeltingElectrodeParameterEdit",
            component: mintalMesPrdSmeltingElectrodeParameterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingElectrodeParameterList",
            name: "mintalMesPrdSmeltingElectrodeParameterList",
            component: mintalMesPrdSmeltingElectrodeParameterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingGasCabinetList",
            name: "mintalMesPrdSmeltingGasCabinetList",
            component: mintalMesPrdSmeltingGasCabinetList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingGasCabinetEdit",
            name: "mintalMesPrdSmeltingGasCabinetEdit",
            component: mintalMesPrdSmeltingGasCabinetEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingGasFlowList",
            name: "mintalMesPrdSmeltingGasFlowList",
            component: mintalMesPrdSmeltingGasFlowList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingGasFlowEdit",
            name: "mintalMesPrdSmeltingGasFlowEdit",
            component: mintalMesPrdSmeltingGasFlowEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingSlagIronEdit",
            name: "mintalMesPrdSmeltingSlagIronEdit",
            component: mintalMesPrdSmeltingSlagIronEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingSlagIronList",
            name: "mintalMesPrdSmeltingSlagIronList",
            component: mintalMesPrdSmeltingSlagIronList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingResistanceBeforeIronList",
            name: "mintalMesPrdSmeltingResistanceBeforeIronList",
            component: mintalMesPrdSmeltingResistanceBeforeIronList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingResistanceBeforeIronEdit",
            name: "mintalMesPrdSmeltingResistanceBeforeIronEdit",
            component: mintalMesPrdSmeltingResistanceBeforeIronEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingDrillParameterEdit",
            name: "mintalMesPrdSmeltingDrillParameterEdit",
            component: mintalMesPrdSmeltingDrillParameterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingDrillParameterList",
            name: "mintalMesPrdSmeltingDrillParameterList",
            component: mintalMesPrdSmeltingDrillParameterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingPelletFeedingEdit",
            name: "mintalMesPrdSmeltingPelletFeedingEdit",
            component: mintalMesPrdSmeltingPelletFeedingEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingPelletFeedingList",
            name: "mintalMesPrdSmeltingPelletFeedingList",
            component: mintalMesPrdSmeltingPelletFeedingList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingSubstationRecordList",
            name: "mintalMesPrdSmeltingSubstationRecordList",
            component: mintalMesPrdSmeltingSubstationRecordList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingSubstationRecordEdit",
            name: "mintalMesPrdSmeltingSubstationRecordEdit",
            component: mintalMesPrdSmeltingSubstationRecordEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingFurnacePowerFailureRecordList",
            name: "mintalMesPrdSmeltingFurnacePowerFailureRecordList",
            component: mintalMesPrdSmeltingFurnacePowerFailureRecordList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingFurnacePowerFailureRecordEdit",
            name: "mintalMesPrdSmeltingFurnacePowerFailureRecordEdit",
            component: mintalMesPrdSmeltingFurnacePowerFailureRecordEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingCeramicFilterParameterEdit",
            name: "mintalMesPrdPelletizingCeramicFilterParameterEdit",
            component: mintalMesPrdPelletizingCeramicFilterParameterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingCeramicFilterParameterList",
            name: "mintalMesPrdPelletizingCeramicFilterParameterList",
            component: mintalMesPrdPelletizingCeramicFilterParameterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdFurnaceBatchList",
            name: "mintalMesPrdFurnaceBatchList",
            component: mintalMesPrdFurnaceBatchList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdFurnaceBatchEdit",
            name: "mintalMesPrdFurnaceBatchEdit",
            component: mintalMesPrdFurnaceBatchEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingPreheatingKilnStopEdit",
            name: "mintalMesPrdSmeltingPreheatingKilnStopEdit",
            component: mintalMesPrdSmeltingPreheatingKilnStopEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingPreheatingKilnStopList",
            name: "mintalMesPrdSmeltingPreheatingKilnStopList",
            component: mintalMesPrdSmeltingPreheatingKilnStopList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdManagePlanEdit",
            name: "mintalMesPrdManagePlanEdit",
            component: mintalMesPrdManagePlanEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdManagePlanList",
            name: "mintalMesPrdManagePlanList",
            component: mintalMesPrdManagePlanList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingGrindingParameterEdit",
            name: "mintalMesPrdPelletizingGrindingParameterEdit",
            component: mintalMesPrdPelletizingGrindingParameterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingIngredientPlanList",
            name: "mintalMesPrdPelletizingIngredientPlanList",
            component: mintalMesPrdPelletizingIngredientPlanList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingGrindingParameterList",
            name: "mintalMesPrdPelletizingGrindingParameterList",
            component: mintalMesPrdPelletizingGrindingParameterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingIngredientPlanEdit",
            name: "mintalMesPrdPelletizingIngredientPlanEdit",
            component: mintalMesPrdPelletizingIngredientPlanEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingFilterParameterList",
            name: "mintalMesPrdPelletizingFilterParameterList",
            component: mintalMesPrdPelletizingFilterParameterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingIngredientPlanItemList",
            name: "mintalMesPrdPelletizingIngredientPlanItemList",
            component: mintalMesPrdPelletizingIngredientPlanItemList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingFilterParameterEdit",
            name: "mintalMesPrdPelletizingFilterParameterEdit",
            component: mintalMesPrdPelletizingFilterParameterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingBallingParameterList",
            name: "mintalMesPrdPelletizingBallingParameterList",
            component: mintalMesPrdPelletizingBallingParameterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingBallingParameterEdit",
            name: "mintalMesPrdPelletizingBallingParameterEdit",
            component: mintalMesPrdPelletizingBallingParameterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingRoastingParameterEdit",
            name: "mintalMesPrdPelletizingRoastingParameterEdit",
            component: mintalMesPrdPelletizingRoastingParameterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingRoastingParameterList",
            name: "mintalMesPrdPelletizingRoastingParameterList",
            component: mintalMesPrdPelletizingRoastingParameterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingWaterSystemParameterList",
            name: "mintalMesPrdPelletizingWaterSystemParameterList",
            component: mintalMesPrdPelletizingWaterSystemParameterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingWaterSystemParameterEdit",
            name: "mintalMesPrdPelletizingWaterSystemParameterEdit",
            component: mintalMesPrdPelletizingWaterSystemParameterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingProductTreatmentParameterEdit",
            name: "mintalMesPrdPelletizingProductTreatmentParameterEdit",
            component: mintalMesPrdPelletizingProductTreatmentParameterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingProductTreatmentParameterList",
            name: "mintalMesPrdPelletizingProductTreatmentParameterList",
            component: mintalMesPrdPelletizingProductTreatmentParameterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPelletizingIngredientPlanItemEdit",
            name: "mintalMesPrdPelletizingIngredientPlanItemEdit",
            component: mintalMesPrdPelletizingIngredientPlanItemEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingElectrodeDischargePlanEdit",
            name: "mintalMesPrdSmeltingElectrodeDischargePlanEdit",
            component: mintalMesPrdSmeltingElectrodeDischargePlanEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingElectrodeDischargePlanList",
            name: "mintalMesPrdSmeltingElectrodeDischargePlanList",
            component: mintalMesPrdSmeltingElectrodeDischargePlanList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdIronOutputList",
            name: "mintalMesPrdIronOutputList",
            component: mintalMesPrdIronOutputList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdIronOutputEdit",
            name: "mintalMesPrdIronOutputEdit",
            component: mintalMesPrdIronOutputEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPowerStationRecordList",
            name: "mintalMesPrdPowerStationRecordList",
            component: mintalMesPrdPowerStationRecordList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdPowerStationRecordEdit",
            name: "mintalMesPrdPowerStationRecordEdit",
            component: mintalMesPrdPowerStationRecordEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSubstationPowerRecordList",
            name: "mintalMesPrdSubstationPowerRecordList",
            component: mintalMesPrdSubstationPowerRecordList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSubstationPowerRecordEdit",
            name: "mintalMesPrdSubstationPowerRecordEdit",
            component: mintalMesPrdSubstationPowerRecordEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionEquipQuotaList",
            name: "mintalMesPrdProductionEquipQuotaList",
            component: mintalMesPrdProductionEquipQuotaList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdProductionEquipQuotaEdit",
            name: "mintalMesPrdProductionEquipQuotaEdit",
            component: mintalMesPrdProductionEquipQuotaEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdGenertorSetDowntimeEdit",
            name: "mintalMesPrdGenertorSetDowntimeEdit",
            component: mintalMesPrdGenertorSetDowntimeEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdGenertorSetDowntimeList",
            name: "mintalMesPrdGenertorSetDowntimeList",
            component: mintalMesPrdGenertorSetDowntimeList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdFieldOpcConfigList",
            name: "mintalMesPrdFieldOpcConfigList",
            component: mintalMesPrdFieldOpcConfigList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdFieldOpcConfigEdit",
            name: "mintalMesPrdFieldOpcConfigEdit",
            component: mintalMesPrdFieldOpcConfigEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingCirculatingWaterEdit",
            name: "mintalMesPrdSmeltingCirculatingWaterEdit",
            component: mintalMesPrdSmeltingCirculatingWaterEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingCirculatingWaterList",
            name: "mintalMesPrdSmeltingCirculatingWaterList",
            component: mintalMesPrdSmeltingCirculatingWaterList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingMaterialConsumptionList",
            name: "mintalMesPrdSmeltingMaterialConsumptionList",
            component: mintalMesPrdSmeltingMaterialConsumptionList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/prd/mintalMesPrdSmeltingMaterialConsumptionEdit",
            name: "mintalMesPrdSmeltingMaterialConsumptionEdit",
            component: mintalMesPrdSmeltingMaterialConsumptionEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            }
]